import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '../Buttons/ButtonBase';
import ComboText from '../../components/ComboText';
import { ESPECIALIDADITEMS, GRADESTUDY } from '../../utils/ConstantsMain';
import { isMobile } from 'react-device-detect';
import "./addLawyers.scss";
import { FieldArray } from 'formik';
import LawyerEducationForm from './LawyerEducationForm';
import LawyerLaboralForm from './LawyerLaboralForm';
import MainPhoto from '../AddHolders/MainPhoto';
import { storage } from '../../configs/environments/firebase/firebaseApp';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { activeDeleteImgProfile, activeDeleteReset } from "../../store/actions/DeleteImageAction";
import { showLoading } from "../../store/actions/LoadingActions";
import {
  TextField,
  ClickAwayListener,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
  Tooltip,
  InputLabel,
  MenuItem,
  FormHelperText,
  FormControl,
  Select,
  Grid,
} from '@material-ui/core';

const styles = () => ({
  form: {
    margin: 0,
    '@media screen and (max-width: 500px)': {

    },
  },
  select: {
    borderRadius: 2,
    border: '1px solid rgb(150,150,150)',
    '&:hover': {
      border: '1px solid rgba(0, 0, 0, 0.87)',
    },
  },
  selectRoot: {
    height: 74,
    overflow: 'auto',
    whiteSpace: 'normal',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectMenu: {
    padding: '10px 14px',
    fontSize: 16,
    lineHeight: 1,
  },
  inputLabelRoot: {
    transform: 'translate(14px, 16px) scale(1)',
  },
  heightSelect: {
    height: 76,
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296
    },
  },
  personalData: {
    color: '#10587f',
    fontSize: 18,
    margin: '0 0 24px 0',
    fontWeight: 'bold',
  },
  lawyer: {
    color: '#013957',
    fontSize: 18,
    margin: '0 0 30px 0',
    fontWeight: 'bold',
  },
  personalEducation: {
    color: '#10587f',
    fontSize: 18,
    margin: '0 0 30px 0',
    fontWeight: 'bold'
  },
  personalLaboralExperience: {
    color: '#10587f',
    fontSize: 18,
    margin: '0 0 30px 0',
    fontWeight: 'bold'
  },
  inputLabelShrink: {
    transform: 'translate(14px, -6px) scale(0.75)',
    backgroundColor: '#fff',
    zIndex: 10,
  },
  listItemText: {
    fontSize: 14,
  },
  formHelperTextRoot: {
    margin: '8px 14px',
    marginBottom: 0,
  },
  inputError: {
    border: '1px solid #d74242',
    '&:hover': {
      border: '1px solid #d74242',
    },
  },
  TextField: {
    maxWidth: '536px',
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
      width: 296
    },
  },
  TextField_small: {
    maxWidth: '144px',
    marginRight: '24px',
  },
  Grid: {
    paddingLeft: '8px',
  },
  input_icon: { 
    maxWidth: '560px'
  },
  input_iconCedula: {
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '75%',
  },
  input_iconArea: { 
    maxWidth: '544px',
    paddingRight: 8,
    minWidth: '79%',
    margin: '0 0 -28px 0',
  },
  areaContainer: {
    margin: '0 0 30px 0',
  },
  specialtyGrid: {
    flexWrap: 'nowrap'
  },
  rootFormControl :{
    display : 'flex',
    alignItems: 'center',
  },
  customTooltip: {
    backgroundColor: '#094565',
    margin: '10px 8px 0',
    padding: 8,
    maxWidth: 232,
    lineHeight: 1.2,
  },
  tooltipParagraph: {
    margin: 0,
    fontSize: 14,
    '& b': {
      fontSize: 14,
      fontWeight: 'bold',
    },
  },
  tooltipImage: {
    margin: '12px 0 0',
  },
  expandButton: {
    display: 'flex',
    color: '#013957',
    cursor: 'pointer',
  },
  ButtonBase: {
    padding: 0,
    margin: 0,
    width: 144,
    minWidth: 'initial',
    borderWidth: 1,
  },
  linkStyle: {
    width: 144,
    margin: '0 10px 0 0',
    '&:$last-child': {
      margin: 0
    }
  },
  comboText: {
    '@media screen and (max-width: 400px)': {
      maxWidth: 296,
    },
  },
  '@media screen and (min-width: 983px) and (max-width: 1179.98px)': {
    input_iconArea: { 
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconCedula: {
      maxWidth: '92%',
      minWidth: '92%',
    },
  },
  '@media screen and (min-width: 769px) and (max-width: 982.98px)': {
    input_iconArea: { 
      maxWidth: '92%',
      minWidth: '92%',
    },
    input_iconCedula: {
      maxWidth: '92%',
      minWidth: '92%',
    },
  },
  '@media screen and (max-width: 768.98px)': {
    input_iconArea: {
      width: '89%',
      margin: '0 14px 22px 0',
      minWidth: '77%'
    },
    input_iconCedula: {
      minWidth: '77%',
      width: '92%',
    },
    areaContainer: {
      margin: '0 0 -25px 0',
    },
  }
});

const LawyerForm = props => {
  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    touched,
    errors,
    classes,
    setFieldValue,
    evento,
    collaboratorPosition,
    nElem,
    isObjectFull,
    item,
    uid,
    deleteImg,
    lawyers,
    resetForm,
    activeDeleteReset,
    activeDeleteImgProfile,
    showLoading,
  } = props;

  useEffect(() => {
    if (collaboratorPosition) {
      setFieldValue('collaboratorPosition', collaboratorPosition)
    }
  }, [collaboratorPosition, setFieldValue])

  const handleChangeMultiple = field => event => {
    event.preventDefault();
    let value = event.target.value;

    setFieldValue(field, value);
  };

  const handleTagSelect = field => value => {
    setFieldValue(field, value);
  };

  const [cancelData, setCancelData] = useState(false);

  const handleCancel = event => {
    event.preventDefault();
    resetForm()
    if (!values.flagEdit) {
      setFieldValue('collaboratorPosition', '')
      values['imgProfile'] = ''
      setCancelData(true)
    }
    evento();
    if (values.flagEdit) {
      activeDeleteReset()
    }
  };

  const addToFirebaseStorage = async (elem, routeName, subRouteName) => {
    return new Promise(async (resolve, reject) => {
      if (typeof values.imgProfile === 'object') {
        try {
          if (Object.entries(elem).length <= 0) { 
          let sPhoto = `CA_${Math.floor(Math.random() * 10)}_${nElem}`;
          await storage
            .ref(`profileImage/${uid}/${routeName}/${subRouteName}/${sPhoto}`)
            .put(elem)
            .on(
              'state_changed',
              snapShot => { },
              err => { },
              async () => {
                try {
                  const getUrl = await storage.ref(`profileImage/${uid}/${routeName}/`).child(`${subRouteName}/${sPhoto}`).getDownloadURL()
                  values['imgProfile'] = getUrl
                  resolve(getUrl)
                } catch (error) {
                  console.log('error ',error);
                }
              }
            )
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        resolve()
      }
    })
  }

  const deleteFromFirebaseStorage = () => {
    return new Promise((resolve, reject) => {
      if (
        lawyers &&
        lawyers[item] &&
        lawyers[item].imgProfile &&
        lawyers[item].imgProfile.includes('firebase') &&
        deleteImg.imgProfile
      ) {
        try {
          const response = storage
            .refFromURL(lawyers[item].imgProfile)
            .delete()
          return resolve(response)
        } catch (error) {
          return reject(error);
        }
      } else {
        return resolve()
      }
    });
  };

  const someIsFile = () => {
    let isFile = false
    if (typeof values.imgProfile === 'object') {
      isFile = true
    }
    return isFile
  }

  const onSubmit =  async (event) => {
    event.preventDefault()
    // showLoading()
    const isFile = someIsFile()
    try {
      if (values.flagEdit) {        
        const deleteImgProfile = await deleteFromFirebaseStorage()
        await Promise.all([deleteImgProfile])
      }

      if (isFile) {
        const imgProfile = await addToFirebaseStorage(values.imgProfile, 'lawyers', 'subavatar');
        await Promise.all([imgProfile])

        setCancelData(true)
        activeDeleteReset()
        handleSubmit()
      } else {
        activeDeleteReset()
        handleSubmit()
      }
    } catch (error) {
      console.log(error);
    }
  }

  const [openCedula, setOpenCedula] = useState(false);

  const handleTooltipCloseCedula = () => {
    setOpenCedula(false);
  };

  const handleTooltipOpenCedula = () => {
    setOpenCedula(true);
  };

  const [openAreas, setOpenAreas] = useState(false);

  const handleTooltipCloseAreas = () => {
    setOpenAreas(false);
  };

  const handleTooltipOpenAreas = () => {
    setOpenAreas(true);
  };

  return (
    <>
      <form className={classes.form}>

        <MainPhoto
          nElem={nElem}
          name={'imgProfile'}
          value={values.imgProfile}
          setFieldValue={setFieldValue}
          cancelData={cancelData}
          setCancelData={setCancelData}
          flagEdit={values.flagEdit}
        />

        <p className={classes.personalData}>Datos personales</p>
        <p className={classes.lawyer}>
          {values.collaboratorPosition && values.collaboratorPosition}
        </p>

        <FormControl
          error={touched.gender && errors.gender ? true : false}
          component="fieldset"
        >
          <div className={classes.rootFormControl}>
            <FormLabel
              component="legend"
              style={{ flexGrow: 0.5, color: '#484848', fontWeight: 'bold' }}
            >
              Género:
            </FormLabel>
            <RadioGroup
              row
              aria-label="gender"
              name="gender"
              defaultValue="male"
              value={values.gender ? values.gender : 'male'}
              onChange={handleChangeMultiple('gender')}
              onBlur={handleBlur}
            >
              <FormControlLabel
                value="male"
                control={<Radio color="secondary" />}
                label="Hombre"
              />
              <FormControlLabel
                value="female"
                control={<Radio color="secondary" />}
                label="Mujer"
              />
            </RadioGroup>
          </div>
          {touched.gender && errors.gender ? (
            <FormHelperText
              color="error"
              classes={{ root: classes.formHelperText }}
            >
              {errors.gender}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>

        <div className="contentInputsMember">
        <TextField
          label="Nombre del abogado*"
          id="nameLawyer"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.nameLawyer}
          helperText={
            touched.nameLawyer && errors.nameLawyer ? errors.nameLawyer : ''
          }
          error={touched.nameLawyer && errors.nameLawyer ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <TextField
          label="Apellido paterno*"
          id="firstLastname"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.firstLastname}
          helperText={
            touched.firstLastname && errors.firstLastname
              ? errors.firstLastname
              : ''
          }
          error={touched.firstLastname && errors.firstLastname ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <TextField
          label="Apellido materno*"
          id="secondLastName"
          type="text"
          variant="outlined"
          onBlur={handleBlur}
          onChange={handleChange}
          value={values.secondLastName}
          helperText={
            touched.secondLastName && errors.secondLastName
              ? errors.secondLastName
              : ''
          }
          error={touched.secondLastName && errors.secondLastName ? true : false}
          fullWidth
          classes={{ root: classes.TextField }}
        />

        <FormControl
          style={{ maxWidth: '536px' }}
          classes={{ root: classes.heightSelect }}
          variant="outlined"
          error={touched.Items && errors.Items ? true : false}
        >
          <InputLabel
            htmlFor="select-multiple-checkbox"
            classes={{
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
            }}
          >
            {'Último grado de estudios'}
          </InputLabel> 
            <Select
              id='gradeStudy'
              name='gradeStudy'
              value={values.gradeStudy ? values.gradeStudy : []}

              onChange={handleChange}
            >
              {GRADESTUDY && GRADESTUDY.map((item, index) => (
                <MenuItem key={index} value={item.value} >
                  {item.name}
                </MenuItem>
              ))}
          </Select>
          {touched.Items && errors.Items ? (
            <FormHelperText classes={{ root: classes.formHelperTextRoot }}>
              {errors.Items}
            </FormHelperText>
          ) : (
            ''
          )}
        </FormControl>
        </div>
        <Grid item xs container direction="row">
          <Grid item xs classes={{ root: classes.input_iconCedula }}>
            <TextField
              label="Cédula profesional"
              id="cedula"
              type="text"
              variant="outlined"
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.cedula}
              helperText={touched.cedula && errors.cedula ? errors.cedula : ''}
              error={touched.cedula && errors.cedula ? true : false}
              fullWidth
              classes={{ root: classes.TextField }}
            />
          </Grid>
          <Grid item>
            <div>
              {isMobile === true ?
                <ClickAwayListener onClickAway={handleTooltipCloseCedula}>
                  <Tooltip
                    onClose={handleTooltipCloseCedula}
                    open={openCedula}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    classes={{tooltip: classes.customTooltip}}
                    title={
                      <p className={classes.tooltipParagraph}>
                        El campo "cédula profesional" <b>no es obligatorio</b> pero recomendamos
                        completarlo con fines de <b>credibilidad</b> y <b>veracidad</b> de la información proporcionada.
                      </p>
                    }
                    placement='left'
                    >
                      <img 
                        src="../../img/profile/ayuda.png"
                        alt="?"
                        onClick={handleTooltipOpenCedula}
                        className={classes.tooltipImage}
                      />
                  </Tooltip>
                </ClickAwayListener> :
                <Tooltip
                  classes={{tooltip: classes.customTooltip}}
                  title={
                    <p className={classes.tooltipParagraph}>
                      El campo "cédula profesional" <b>no es obligatorio</b> pero recomendamos
                      completarlo con fines de <b>credibilidad</b> y <b>veracidad</b> de la información proporcionada.
                    </p>
                  }
                  placement='bottom'
                >
                  <img
                    src="../../img/profile/ayuda.png"
                    alt="?"
                    className={classes.tooltipImage}
                  />
                </Tooltip>
              }
            </div>
          </Grid>
        </Grid>

        <div className={classes.areaContainer}>
          <Grid container classes={{ root: classes.specialtyGrid }}>
            <Grid item classes={{root: classes.input_iconArea}}>
              <ComboText
                labelText={'Áreas de práctica*'}
                itemsCombo={ESPECIALIDADITEMS}
                widthField={536}
                multiple={true}
                handleChanges={handleTagSelect('specialties')}
                errors={errors.specialties}
                touched={touched.specialties}
                handleBlur={handleBlur}
                name={'specialties'}
                valuesMul={values.specialties}
                cierre={true}
              />
            </Grid>
            <Grid item>
              <div>
                {isMobile === true ?
                  <ClickAwayListener onClickAway={handleTooltipCloseAreas}>
                    <Tooltip
                      onClose={handleTooltipCloseAreas}
                      open={openAreas}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      classes={{tooltip: classes.customTooltip}}
                      title={
                        <p className={classes.tooltipParagraph}>
                          Las áreas de especialidad que elijas en este campo <b>solo pertenecen</b> al área de conocimiento del <b>abogado</b>.
                        </p>
                      }
                      placement='left'
                    >
                      <img 
                        style={{ marginTop: 12 }}
                        src="../../img/profile/ayuda.png"
                        alt="?"
                        onClick={handleTooltipOpenAreas}
                      />
                    </Tooltip>
                  </ClickAwayListener> :
                  <Tooltip
                    classes={{tooltip: classes.customTooltip}}
                    title={
                      <p className={classes.tooltipParagraph}>
                        Las áreas de especialidad que elijas en este campo <b>solo pertenecen</b> al área de conocimiento del <b>abogado</b>.
                      </p>
                    }
                    placement='bottom'
                  >
                    <img style={{ marginTop: 12 }} src="../../img/profile/ayuda.png" alt="?" />
                  </Tooltip>
                }
              </div>
            </Grid>
          </Grid>
        </div>

        <p className={classes.personalEducation}>Educación</p>

        <FieldArray
          name='education'
          render={educationHelper => {
            return (
              <>
                {values.education.map((educationItem, index) => (
                    <LawyerEducationForm
                      index={index}
                      key={index}
                      education={educationItem}
                      educationHelper={educationHelper}
                      errors={errors}
                      touched={touched}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      setFieldValue={setFieldValue}
                    />
                  )
                )}
                <div className="generalAdd" 
                  onClick={() => {
                    const evaluation = isObjectFull(values.education, values)
                    if (values.education.length < 2 && evaluation) {
                      educationHelper.push({
                        nameUniversity: '',
                        receivedGradeStudy: '',
                        discipline: '',
                        firstYear: '',
                        lastYear: '',
                      })
                    }
                  }}
                >
                  <div
                    className={classes.expandButton}
                    style={{
                      opacity: (values.education && values.education.length === 2) ||
                                isObjectFull(values.education, values) === false ?
                                0.5 : 1,
                      cursor: (values.education && values.education.length === 2) ||
                                isObjectFull(values.education, values) === false ? 
                                'not-allowed' : 'pointer',
                    }}
                  >
                    <img src="/img/profile/plus.svg" alt="" />
                    <p className="buttonPlus">Añadir universidad o centro de estudios</p>
                  </div>
                  <p className="plusParagraph">Puedes añadir hasta dos</p>
                </div>
              </>
            )}
          }
        />

        <p className={classes.personalLaboralExperience}>Experiencia laboral</p>

        <FieldArray
          name='laboral'
          render={laboralHelper => {
            return (
              <>
                {values.laboral.map((laboralItem, index, laboralArray) => (
                  <LawyerLaboralForm
                    index={index}
                    key={index}
                    laboral={laboralItem}
                    laboralArray={laboralArray}
                    laboralHelper={laboralHelper}
                    errors={errors}
                    touched={touched}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                  />
                ))}
                <div className="generalAdd"
                  onClick={() => {
                    const evaluation = isObjectFull(values.laboral, values)
                    if (values.laboral.length < 2 && evaluation) {
                      laboralHelper.push({
                        companyPosition: '',
                        nameCompany: '',
                        actualCompanyPosition: false,
                        firstMonth: '',
                        firstLaboralYear: '',
                        lastMonth: '',
                        lastLaboralYear: '',
                      })
                    }
                  }}
                >
                  <div
                    className={classes.expandButton}
                    style={{
                      opacity: (values.laboral && values.laboral.length === 2) ||
                                isObjectFull(values.laboral, values) === false ?
                                0.5 : 1,
                      cursor: (values.laboral && values.laboral.length === 2) ||
                                isObjectFull(values.laboral, values) === false ? 
                                'not-allowed' : 'pointer',
                    }}
                  >
                    <img src="/img/profile/plus.svg" alt="" />
                    <p className="buttonPlus">Añadir experiencia laboral</p>
                  </div>
                  <p className="plusParagraph">Puedes añadir hasta dos</p>
                </div>
              </>
            )}
          }
        />

        <div className="addLawyers_horizontal-layout" style={{ marginTop: 15 }}>
          <div style={{ display: 'flex' }}>
            <ButtonBase
              type="submit"
              onClick={onSubmit}
              variant="primary"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase }
              style={{ marginRight: 16}}
              // disabled={!isValid}
            >
             Guardar
            </ButtonBase>

            <ButtonBase
              type="submit"
              onClick={handleCancel}
              variant="primarySolidOutlined"
              linkStyle={classes.linkStyle}
              className={classes.ButtonBase}
            >
              Cancelar
            </ButtonBase>
          </div>

          {/* {values.flagEdit && <p className="deleteLawyers" onClick={DeleteProfile}>
            Eliminar perfil
          </p>} */}
        </div>

      </form>
    </>
  )
};

const mapStateToProps = state => ({
  uid: state.authClient.uid,
  lawyers: state.authClient.lawyers,
  deleteImg: state.DeleteImageReducer.deleteImg
})

const mapDispatchToProps = dispatch => ({
  showLoading: () => dispatch(showLoading()),
  activeDeleteImgProfile: (boolCancel) =>
    dispatch(activeDeleteImgProfile(boolCancel)),
  activeDeleteReset: () =>
    dispatch(activeDeleteReset())
});

const LawyerFormCompose = compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(LawyerForm)

export default withStyles(styles)(LawyerFormCompose);
